// src/services/authService.ts
import apiClient from './apiClient';

interface RegisterRequest {
    name: string;
    phone: string;
    password: string;
}

interface RegisterResponse {
    message: string;
}

interface IsPhoneInDatabaseResponse {
    is_phone_in_database: boolean;
}

export const isPhoneInDatabase = async (phone: string): Promise<boolean> => {
    try {
        const response = await apiClient.get<IsPhoneInDatabaseResponse>(`/api/is-phone-in-database`, {
            params: { phone },
        }
        );
        return response.data.is_phone_in_database;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
}

export const register = async (
    data: RegisterRequest
): Promise<RegisterResponse> => {
    try {
        const response = await apiClient.post<RegisterResponse>('/api/register', data);
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};

export const guestRegister = async (data: { name: string; phone: string }): Promise<RegisterResponse> => {
    try {
        const response = await apiClient.post<RegisterResponse>("/api/guest-register", data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

interface VerifyPhoneRequest {
    phone: string;
    code: string;
}

interface VerifyPhoneResponse {
    message: string;
}

export const verifyPhone = async (
    data: VerifyPhoneRequest
): Promise<VerifyPhoneResponse> => {
    try {
        const response = await apiClient.post<VerifyPhoneResponse>(
            '/api/verify',
            data
        );
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};

interface LoginRequest {
    phone: string;
    password: string;
}

interface User {
    id: number;
    is_admin: boolean;
    is_phone_verified: boolean;
    is_super_admin: boolean;
    name: string;
    phone: string;
    created_at: string;
}

interface LoginResponse {
    token: string;
    refresh_token: string;
    user: User;
}

export const login = async (data: LoginRequest): Promise<LoginResponse> => {
    try {
        const response = await apiClient.post<LoginResponse>('/api/login', data);
        const { token, user } = response.data;

        // Сохраняем токены в localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};

interface RequestPasswordResetRequest {
    phone: string;
}

interface RequestPasswordResetResponse {
    message: string;
}

export const requestPasswordReset = async (
    data: RequestPasswordResetRequest
): Promise<RequestPasswordResetResponse> => {
    try {
        const response = await apiClient.post<RequestPasswordResetResponse>(
            '/api/request-password-reset',
            data
        );
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};

interface ResetPasswordRequest {
    phone: string;
    code: string;
    password: string;
}

interface ResetPasswordResponse {
    message: string;
}

export const resetPassword = async (
    data: ResetPasswordRequest
): Promise<ResetPasswordResponse> => {
    try {
        const response = await apiClient.post<ResetPasswordResponse>(
            '/api/reset-password',
            data
        );
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};

//resend-code resending the code to the phone number
interface ResendCodeRequest {
    phone: string;
}

interface ResendCodeResponse {
    message: string;
}

export const resendCode = async (
    data: ResendCodeRequest
): Promise<ResendCodeResponse> => {
    try {
        const response = await apiClient.post<ResendCodeResponse>(
            '/api/resend-code',
            data
        );
        return response.data;
    } catch (error) {
        // Обработка ошибок
        throw error;
    }
};
